import React from "react";
import { FaStar, FaEnvelope, FaLink, FaSmile } from "react-icons/fa";
import { HiSparkles } from "react-icons/hi";

const HomePage = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-50 to-gray-100">
      <div className="flex flex-col justify-center items-center min-h-screen py-6 px-4">
        <div className="w-full max-w-md bg-white rounded-2xl shadow-xl shadow-gray-200/50 overflow-hidden">
          <div className="bg-gradient-to-r from-blue-500 to-blue-600 px-6 py-5 text-white text-center">
            <h1 className="text-xl font-semibold">Welcome to ReviewBoost </h1>
          </div>

          <div className="p-6">
            <div className="flex justify-center mb-4">
              <div className="w-16 h-16 bg-gradient-to-br from-yellow-100 to-orange-100 rounded-full flex items-center justify-center">
                <HiSparkles className="text-yellow-500 text-3xl" />
              </div>
            </div>

            <div className="text-center mb-5">
              <p className="text-gray-600">
                Share your feedback and help businesses improve their services.
              </p>
            </div>

            <div className="bg-gray-50 rounded-xl p-5 mb-5">
              <h3 className="font-semibold text-gray-800 text-sm mb-4">
                How to access your review page:
              </h3>

              <ol className="space-y-4">
                <li className="flex items-start gap-3">
                  <div className="flex items-center gap-2 text-sm text-gray-700 pt-1">
                    <FaEnvelope className="text-blue-500 flex-shrink-0" />
                    <span>
                      Check the SMS or email you received from the business.
                    </span>
                  </div>
                </li>
                <li className="flex items-start gap-3">
                  <div className="flex items-center gap-2 text-sm text-gray-700 pt-1">
                    <FaLink className="text-blue-500 flex-shrink-0" />
                    <span>Click on the unique link provided.</span>
                  </div>
                </li>
                <li className="flex items-start gap-3">
                  <div className="flex items-center gap-2 text-sm text-gray-700 pt-1">
                    <FaSmile className="text-blue-500 flex-shrink-0" />
                    <span>Rate your experience and leave feedback!</span>
                  </div>
                </li>
              </ol>
            </div>

            <div className="text-center mb-4">
              <p className="text-sm text-gray-500 mb-2">
                Your link will look like:
              </p>
              <div className="bg-gray-100 px-4 py-2 rounded-lg inline-block">
                <code className="text-sm text-gray-700">
                  {window.location.origin}/
                  <span className="text-blue-500 font-medium">your-code</span>
                </code>
              </div>
            </div>

            <div className="bg-blue-50 rounded-xl p-4 text-center">
              <p className="text-sm text-gray-600">
                Don't have a link? Contact us at
              </p>
              <a
                href="mailto:support@growthzilla.com"
                className="text-blue-500 font-medium text-sm hover:underline"
              >
                support@growthzilla.com
              </a>
            </div>
          </div>
        </div>

        <p className="text-gray-400 text-xs mt-6">Powered by ReviewBoost</p>
      </div>
    </div>
  );
};

export default HomePage;
